import React from 'react';

import { Box, Button, SvgIcon } from '@mui/material';

import { useCognitoGetSsoUrlLazyQuery } from 'src/api';
import { HRLogicsIcon } from 'src/assets';
import { SSO_STATE_STORAGE_KEY } from 'src/constants/auth';
import { useNotification } from 'src/hooks/app';

type SsoLoginProps = {
  isLoginDisabled: boolean;
  switchLoginDisabledState: (isDisabled: boolean) => void;
};

export const SsoLogin: React.FC<SsoLoginProps> = ({
  isLoginDisabled,
  switchLoginDisabledState,
}) => {
  const { createApolloContext } = useNotification();

  const [cognitoGetSsoUrl, { loading }] = useCognitoGetSsoUrlLazyQuery({
    context: createApolloContext({ errorMessage: 'SSO sign-in failed' }),
  });

  const ssoRedirect = React.useCallback(async () => {
    switchLoginDisabledState(true);
    try {
      const { data } = await cognitoGetSsoUrl();
      const redirectUrl = data?.cognitoGetSsoUrl;
      if (redirectUrl) {
        // Verified by SsoCallback against the `state` Cognito echoes back (login-CSRF guard).
        sessionStorage.setItem(
          SSO_STATE_STORAGE_KEY,
          new URL(redirectUrl).searchParams.get('state') ?? '',
        );
        window.location.replace(redirectUrl);
      }
    } finally {
      switchLoginDisabledState(false);
    }
  }, [switchLoginDisabledState, cognitoGetSsoUrl]);

  return (
    <Box textAlign="center">
      <Button
        variant="contained"
        onClick={ssoRedirect}
        loading={loading}
        disabled={isLoginDisabled}
        startIcon={
          <SvgIcon>
            <HRLogicsIcon />
          </SvgIcon>
        }
      >
        Sign in with HRLogics SSO
      </Button>
    </Box>
  );
};
